import PropTypes from "prop-types";

import { AV_VALUES } from "constants/common";

const DetailCard = ({
  cardStyle = "particularDetail",
  detailHead = null,
  detailText,
  detailText2 = null,
  detailTextFontSize = "text-xl",
  detailTextLineHeight = "leading-normal",
  cardWidthClass = "w-full",
  extraClasses = "",
  justifyText = false,
}) => {
  return (
    <section
      className={`p-6 md:p-8 xl:p-10 text-lg bg-accent-back drop-shadow-lg rounded-md ${cardWidthClass} ${extraClasses}`}
    >
      {cardStyle === "routeNum" ? (
        <div>
          <h1 className="text-4xl leading-normal font-fam-hind">
            {detailHead}
          </h1>

          <div className="pr-4 text-xl mb-5 text-rose-700">
            {AV_VALUES[detailText2]}
          </div>

          <div className="pr-4 text-slate-500 text-sm">{detailText}</div>
        </div>
      ) : (
        <>
          {detailHead && (
            <h2 className="text-rose-800 text-md font-semibold mb-5">
              {detailHead}
            </h2>
          )}
          <p
            className={`${detailTextFontSize} ${detailTextLineHeight} break-words tracking-normal ${justifyText ? "xl:text-justify" : ""}`}
          >
            {detailText}
          </p>
        </>
      )}
    </section>
  );
};

DetailCard.propTypes = {
  cardStyle: PropTypes.oneOf(["routeNum", "particularDetail"]),
  detailHead: PropTypes.string,
  detailText: PropTypes.string,
  detailText2: PropTypes.string,
  detailTextFontSize: PropTypes.string,
  detailTextLineHeight: PropTypes.string,
  cardWidthClass: PropTypes.string,
  extraClasses: PropTypes.string,
  justifyText: PropTypes.bool,
  linkContent: PropTypes.string,
};

export default DetailCard;
